import { RootState } from '@/base/stores/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ILocaleState {
    curLocale: string;
    locales: {
        name: string;
        label: string;
    }[];
}

const initialState: ILocaleState  = {
    locales: [],
    curLocale: '',
};

export const localesStateSlice = createSlice({
    name: 'locale',
    initialState,
    reducers: {
        setLocales: (state, action: PayloadAction<{
            name: string;
            label: string;
        }[]>) => {
            state.locales = action.payload;
        },
        setCurLocale: (state, action: PayloadAction<string>) => {
            state.curLocale
        }
    },
});

export const { setLocales, setCurLocale } = localesStateSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectLocales = (state: RootState) => state.locales.locales;
export const selectCurLocale = (state: RootState) => state.locales.curLocale;

export default localesStateSlice.reducer;
